<template>
  <main class="ws-page">
    <header class="ws-page-header">
      <h1 class="ws-page-header__title has-text-weight-bold is-size-2" v-text="$t('Организации и предприятия')"></h1>
      <div class="ws-page-header-actions">
        <button type="button" class="button is-outlined" @click="showUsersUploadPopup">
          Загрузить новых кураторов
        </button>
      </div>
    </header>
    <ws-orgs-list />
  </main>
</template>

<script>
import WsUserUpload from '../components/de/orgs/modals/WsUserUpload.vue'
export default {
  name: 'Orgs',
  methods: {
    showUsersUploadPopup (org) {
      this.$buefy.modal.open({
        parent: this,
        component: WsUserUpload,
        hasModalCard: true,
        props: {},
        canCancel: false,
        events: {}
      })
    }
  }
}
</script>
